import React from 'react'
import { StyledFeatureVariable } from '@mc/feature-variables'
import { Trans, withI18nContext } from '@mc/i18n'
import { PROMO_FEATURE_FLAG } from '@mc/promo-utils'
import { i18nInstance } from '../../i18n'
import { PROMO_I18N_NAMESPACE } from '../../lib/constants'

export const StickyFooterContentTitleComp = ({
  className = 'mc-mr-sm-6',
}: {
  className?: string
}) => (
  <h2
    className={`mc-text--brand mc-text--uppercase ${className}`}
    style={{ fontSize: '28px' }}
  >
    <StyledFeatureVariable
      flagName={PROMO_FEATURE_FLAG}
      variableName='banner_and_sticky_footer_title'
      defaultCopy={
        <Trans i18nKey='common.title' ns={PROMO_I18N_NAMESPACE}>
          <span className='mc-text-color--tertiary mc-mr-1' />
          <span className='mc-text-color--primary mc-mr-1' />
        </Trans>
      }
      ignoreStyle={true}
    />
  </h2>
)

export const StickyFooterContentTitle = withI18nContext(i18nInstance)(
  StickyFooterContentTitleComp,
)
